// extracted by mini-css-extract-plugin
module.exports = {"component":"Label_component__2rrf2","label":"Label_label__EDWeJ"};